import { differenceInDays } from "date-fns"

import getTodaysDateInEST from "./getTodaysDateInEST"

export default function (date = getTodaysDateInEST()) {
  const daysElapsed = differenceInDays(getTodaysDateInEST(), date)

  if (daysElapsed === 0) return "< 1 Day"
  else if (daysElapsed === 1) return `${daysElapsed} Day`
  else if (daysElapsed) return `${daysElapsed} Days`
  else return daysElapsed
}

export const getAgeRange = (date = getTodaysDateInEST()) => {
  const daysElapsed = differenceInDays(getTodaysDateInEST(), date)
  if (daysElapsed === 0) return ["<1 day"]
  else if (daysElapsed >= 1 && daysElapsed <= 2) return ["1-2 days"]
  else if (daysElapsed >= 3 && daysElapsed <= 6) return ["3-6 days"]
  else if (daysElapsed >= 7 && daysElapsed <= 14) return ["7-14 days"]
  else if (daysElapsed) return ["> 14 days"]
  else return []
}
